import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import { StyledAdamTag } from './MetaCRMTag.styles.js';
const _excluded = ["children", "sx"];
function AdamTag(_ref) {
  let {
      children,
      sx
    } = _ref,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledAdamTag, _extends({
    sx: sx
  }, other), /*#__PURE__*/React__default.createElement("span", null, children)));
}
AdamTag.propTypes = {
  option: PropTypes.shape({
    label: PropTypes.string
  }),
  sx: PropTypes.shape({}),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType])
};
AdamTag.defaultProps = {
  option: {
    label: ''
  },
  sx: {},
  children: null
};
export { AdamTag as default };